import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    mainTitle: {
        fontSize: "24px",
        fontWeight: 400,
        fontFamily: "Source Sans 3",
    },
}));
